import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const location         = useLocation();
  const isAdmin          = user?.role === "admin";
  const isCollaborator   = user?.role === "collaborator";
  const isStaff          = isAdmin || isCollaborator;
  const isStudent        = user?.role === "student" || user?.role === "user";
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  const handleLogout = () => { logout(); navigate("/"); setMenuOpen(false); };
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");
  const close = () => setMenuOpen(false);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const StaffLinks = ({ onClick }) => (
    <>
      <Link to="/admin"        className={`navbar-link ${isActive("/admin") ? "active" : ""}`}        onClick={onClick}>Panel</Link>
      <Link to="/admin/perfil" className={`navbar-link ${isActive("/admin/perfil") ? "active" : ""}`} onClick={onClick}>Mi Perfil</Link>
    </>
  );

  const PublicLinks = ({ onClick }) => (
    <>
      <Link to="/"          className={`navbar-link ${location.pathname === "/" ? "active" : ""}`} onClick={onClick}>Inicio</Link>
      <Link to="/clases"    className={`navbar-link ${isActive("/clases")    ? "active" : ""}`}    onClick={onClick}>Clases</Link>
      <Link to="/articulos" className={`navbar-link ${isActive("/articulos") ? "active" : ""}`}    onClick={onClick}>Artículos</Link>
      <Link to="/recursos"  className={`navbar-link ${isActive("/recursos")  ? "active" : ""}`}    onClick={onClick}>Recursos</Link>
      {isStudent && (
        <Link to="/perfil" className={`navbar-link ${isActive("/perfil") ? "active" : ""}`} onClick={onClick}>Mi perfil</Link>
      )}
    </>
  );

  const badgeLabel = isAdmin
    ? `ADMIN: ${user?.first_name || "Admin"}`
    : isCollaborator
      ? `COLAB: ${user?.first_name || "Colaborador"}`
      : `${user?.first_name || ""} ${user?.last_name || ""}`;

  const badgeClass = isAdmin ? "admin" : isCollaborator ? "collaborator" : "user";

  return (
    <nav className="navbar" ref={navRef}>
      {/* Brand */}
      <Link to="/" className="navbar-brand">
        <svg width="36" height="28" viewBox="0 0 28 22" fill="none">
          <rect x="0"  y="14" width="5" height="8"  rx="1" fill="#4a5c2f"/>
          <rect x="7"  y="8"  width="5" height="14" rx="1" fill="#4a5c2f"/>
          <rect x="14" y="4"  width="5" height="18" rx="1" fill="#4a5c2f"/>
          <rect x="21" y="0"  width="5" height="22" rx="1" fill="#0e8a8a"/>
        </svg>
        <span>STATISTIKDATA</span>
      </Link>

      {/* Links — desktop */}
      <div className="navbar-links">
        {isStaff ? <StaffLinks /> : <PublicLinks />}
      </div>

      {/* Auth — desktop */}
      <div className="navbar-auth">
        {user ? (
          <>
            <span className={`navbar-badge ${badgeClass}`}>{badgeLabel}</span>
            <button className="navbar-logout" onClick={handleLogout}>Salir</button>
          </>
        ) : (
          <Link to="/login" className="navbar-login">Iniciar Sesión</Link>
        )}
      </div>

      {/* Hamburguesa */}
      <button className={`navbar-hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
        <span/><span/><span/>
      </button>

      {/* Drawer móvil */}
      {menuOpen && (
        <div className="navbar-drawer">
          {isStaff ? <StaffLinks onClick={close} /> : <PublicLinks onClick={close} />}
          {user ? (
            <button className="navbar-logout" onClick={handleLogout}>Salir</button>
          ) : (
            <Link to="/login" className="navbar-login" onClick={close}>Iniciar Sesión</Link>
          )}
        </div>
      )}
    </nav>
  );
}